import { Component, ChangeDetectorRef, Input, OnInit, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges, AfterContentInit, AfterViewChecked } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  FormControl,
  Validators,
  FormGroup,
  FormArray,
  ValidatorFn
} from '@angular/forms';
import { Store, Actions, ofActionSuccessful, setValue } from '@ngxs/store';
import { Observable, Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SubmissionFormState } from '@shared/states/submission-form/submission-form.state';
import {
  SubmissionFormSection,
  SubmissionFormField,
  Option,
  SubmissionFormStateModel,
  FieldOption,
  FieldType,
  Conditional,
  SubmissionForm,
  Network,
  NetworkRelationPanel,
  PanelByNetwork
} from '@shared/types';
import { dateRange, email } from '@shared/custom-validators';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { SubmissionSuccessComponent } from '@shared/modules/dialogs/submission-success/submission-success.component';
import {
  UploadSubmissionFormFile,
  UploadSubmissionFormFileSuccess,
  UploadSubmissionFormFileError,
  UpdateSubmissionForm,
  UpdateSubmissionFormSuccess,
  GetSubmissionForm,
  GetLocalSubmissionForm,
  GetSubmissionFormError,
  GetLocalSubmissionFormError,
  GetAdminNetworks,
  GetAdminPanelsByNetwork,
  GetAdminPanelsByNetworkSuccess,
  GetAdminNetworksSuccess
} from '@shared/states/submission-form/submission-form.actions';
import { FeaturesService } from '@shared/services/features/features.service';
import {
  UniversityState,
  UniversityStateModel
} from '@shared/states/university/university.state';
import { ControlValidationService } from '@shared/modules/inputs/control-validation.service';
import { AdminService } from '@shared/services/features/admin.service';
@Component({
  selector: 'portal-submission-form',
  templateUrl: './submission-form.component.html',
  styleUrls: ['./submission-form.component.scss']
})
export class SubmissionFormComponent implements OnInit {
  university$ = this.store.select<UniversityStateModel>(UniversityState);
  submissionForm$ = this.store.select<SubmissionFormStateModel>(SubmissionFormState);

  @Input() portalName: string;
  @Input() isAdmin:boolean;
  @Input() pageDefault='/submit';
  readonly acceptWord = `application/msword,
    application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
  readonly acceptPorwerPoint = `application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation`;
  readonly acceptVideo = `video/quicktime, video/x-msvideo, video/x-ms-wmv, video/mp4`;
  readonly fileAccept = `application/x-mspublisher, application/pdf,image/png, image/jpeg,
    ${this.acceptWord}, ${this.acceptPorwerPoint}, ${this.acceptVideo}`;
  form: FormArray;
  sections: Array<SubmissionFormSection>;
  submissionForm: SubmissionForm;
  invalidControls=[];
  showErrors=false;
  captchaTandCError=false;
  formSubscription:Observable<any>;
  optionsBundle: { [key: string]: Array<Option> } = {};
  optionsRequired: { [key: string]: boolean } = {};
  conditionalBundle: { [key: string]: Conditional } = {};
  optionsPanel: { [key: string]: Array<Option> } = {};
  showPanelPublic=false;
  userId:string;
  universityId;
  customErrors = {
    url:
      'Invalid URL, URL must have https:// as protocol and have two or three letters as TDP e.g., .com or .io',
    dateRange: `End date should be no earlier than start date and start date should be no later than end date`,
    maxSize: 'File cannot be higher than 20MB'
  };
  FieldType = FieldType;
  fileLoading: boolean;
  error: boolean;
  siteKey = '6LffUMYUAAAAANqX2VXjL0p0lyTz4yLw5BEtWpx9';
  humanSection: SubmissionFormSection = {
    name: null,
    fields: [
      {
        id: -1,
        fieldPosition: -1,
        field_type: -1,
        name: 'Terms of service',
        value: null,
        icon: null,
        isVisible: true,
        isRequired: true,
        options: [
          {
            display_value:
              'I have agreed by the terms and conditions of the Guidelines.',
              preSelected: false,
              selected: false,
            id: -1,
            position_order: 0,
            active: true
          }
        ]
      }
    ]
  };
  captchaSection: SubmissionFormSection = {
    name: null,
    fields: [
      {
        id: -2,
        fieldPosition: -1,
        field_type: -2,
        name: null,
        value: null,
        isRequired: environment.production?true:false,
        
        icon: null,
        isVisible: true
      }
    ]
  };
  isPublicPortalDisabled:boolean;
  loading = true;
  unsubscribe$ = new Subject();
  networkRelationPanels:NetworkRelationPanel[];
  networksSelected:FieldOption[]=[];
  entrysPanel: { [key: string]: Array<FieldOption> } = {};
  networksLocal:Array<FieldOption>=[];
  networksAdmin:Network[];
  constructor(
    private store: Store,
    private matDialog: MatDialog,
    private actions$: Actions,
    private featuresService: FeaturesService,
    private adminService: AdminService,
    private cdRef: ChangeDetectorRef,
    private controlValidatinoService: ControlValidationService,
    
  ) {}

  ngOnInit() {
    if (!this.portalName) {
      this.featuresService.setCurrentPage(this.pageDefault);
    }
    this.subscriptions();
  }

  subscriptions(): void {
    this.university$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(university$ => {
        const { loading, university } = university$;
        if (loading === false && university) {
          const { id } = university;
          this.universityId=id;

            this.adminService.isPublicPortalDisabled(this.universityId).subscribe(data=>(this.isPublicPortalDisabled=data));
            
          

          if (!this.portalName) {
            this.store.dispatch(new GetSubmissionForm(id));

            if(this.isAdmin){
              this.userId=this.featuresService.getCredential('userId');
              this.store.dispatch(new GetAdminNetworks(id));
              this.store.dispatch(new GetAdminPanelsByNetwork(id, this.userId));
            }
          } else {
            this.store.dispatch(
              new GetLocalSubmissionForm(id, this.portalName)
            );
          }
        }
      });
    this.submissionForm$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(submissionForm$ => {
        const {
          submissionForm,
          localSubmissionForm,
          loading,
          networksAdmin,
          networkRelationPanels
        } = submissionForm$;
        if (submissionForm && loading === false && !this.portalName) {
          this.loading = false;
          if(networkRelationPanels && this.networkRelationPanels===undefined){
            this.networkRelationPanels=[...networkRelationPanels];
          }

          let sections =
            [
              ...submissionForm.sections,
              this.humanSection,
              this.captchaSection
            ] || [];

          //option 1 clone inmutable array
          // let _sectionsClone = sections.map(ele => {
          //   return Object.assign({},ele);
          // });

        //option 2 clone inmutable array
          let _sectionsClone=[];
          sections.forEach(val=>_sectionsClone.push(Object.assign({}, val)));

          // option 1
          // let fields=_sectionsClone.find(section => section.name === "Ad Request").fields.map(ele=>{
          //   return Object.assign({},ele);
          // })

          //option 2
          let fields=[];
          _sectionsClone[1].fields.forEach(val=>fields.push(Object.assign({},val)));

          //validate Affilliation Type field empty preSelecteds
          let fieldsContact=[..._sectionsClone[0].fields];
          let fieldAffiliation=fieldsContact.find(x=>x.name=='Affiliation Type');
          fieldAffiliation=this.checkAffiliationType(fieldAffiliation);
          const index=fieldsContact.findIndex(x=>x.name=='Affiliation Type');
          if(index)
            fieldsContact[index]=fieldAffiliation;

          _sectionsClone.find(section => section.name === "Contact Information").fields=fieldsContact;

          const fieldNetwork=_sectionsClone[1].fields[0];
          if(networksAdmin && this.networksAdmin===undefined){
            this.networksAdmin=networksAdmin;
          }
          let optionsNetwork = this.manageNetworks(fieldNetwork, this.networksAdmin);
          fields.find(x=>x.name==="Network").options=optionsNetwork;
          _sectionsClone.find(section => section.name === "Ad Request").fields=fields;
          sections = this.setValidators(_sectionsClone);
          this.sections=sections;
          if(this.isAdmin){
            if(this.networkRelationPanels && this.networksAdmin && !this.form){
              this.updatePanelsOptions(false);
              this.submissionForm = submissionForm;
              this.sections = this.sortFields(sections);
              this.createForm(this.sections);
              this.setDateValidators();
              this.uploadContentChange();
              this.cdRef.detectChanges();
            }
          }else{
            if (!this.form) {
              this.submissionForm = submissionForm;
              this.sections = this.sortFields(sections);
              this.createForm(this.sections);
              this.setDateValidators();
              this.uploadContentChange();
              this.cdRef.detectChanges();
             }
          }

        }
        if (localSubmissionForm && loading === false && this.portalName) {
          this.loading = false;
          let sections =
            [
              ...localSubmissionForm.sections,
              this.humanSection,
              this.captchaSection
            ] || [];
          sections = this.setValidators(sections);
          if (!this.form) {
            this.submissionForm = localSubmissionForm;
            this.sections = this.sortFields(sections);
            this.createForm(this.sections);
            this.setDateValidators();
            this.uploadContentChange();
            this.cdRef.detectChanges();
          }
        }
        if(!this.formSubscription && this.form){
          this.formSubscription=this.form.valueChanges;
          this.formSubscription.pipe(takeUntil(this.unsubscribe$)).subscribe(()=>{
            this.invalidControls = this.findInvalidControlsRecursive(this.form);
          })
        }
      });

    this.actions$
      .pipe(
        takeUntil(this.unsubscribe$),
        ofActionSuccessful(
          UpdateSubmissionFormSuccess,
          GetSubmissionFormError,
          GetLocalSubmissionFormError,
          GetAdminPanelsByNetworkSuccess
        )
      )
      .subscribe(action => {
        if (action instanceof UpdateSubmissionFormSuccess) {
          if(action.payload instanceof Array){
            let tokens ="";
            let startDate ="";
            let endDate ="";
            action.payload.forEach(payload => {
              tokens += "-" + payload.body.id;
              startDate=payload.body.start_Date;
              endDate=payload.body.end_Date;
            });
            this.formSubmitted(tokens, startDate, endDate);
          }else{
            const { id, Start_Date, End_Date }: any = action.payload;
            this.formSubmitted(id, Start_Date, End_Date);
          }
          
        }
        if (
          action instanceof GetSubmissionFormError ||
          action instanceof GetLocalSubmissionFormError
        ) {
          this.error = true;
        }
        if(action instanceof GetAdminPanelsByNetworkSuccess ||
          action instanceof GetAdminNetworksSuccess){
        }
      });
  }

  manageNetworks(fieldsClone: SubmissionFormField, networksAdmin:Network[]): FieldOption[] {
    this.debugConsoleLog("manageNetworks");
    
    if (this.isAdmin) {
      let field=Object.assign({},fieldsClone);
       if(field.options){
        const _options = field.options.map(x => {
          return Object.assign({}, x);
        });
        _options.map(x => {
          x.display_value = "Public Network: " + x.display_value;
        });
        if(this.isPublicPortalDisabled){
          field.options=[];
        }else{
          field.options=_options;
        }
        
      }

      //Manage Local Network
      if(networksAdmin){
        //sort networks
        let _networks = networksAdmin.map(ele => {
          return Object.assign({}, ele);
        });
           if(networksAdmin.length>0){
            _networks.sort((a, b) => {
              if (a.name < b.name) { return -1; }
              if (a.name > b.name) { return 1; }
              return 0;
            });
          }
        //update networks option
        this.networksLocal = _networks.filter(x => x.type === "local").map((network, index) => ({
          active: network.active,
          //preSelected: network.preSelected,
          preSelected: false, //false in local networks because admin page have issue with the panel/network options
          selected:  network.selected,
          id: network.id,
          display_value: 'Local Network: ' + network.name,
          position_order: index,
        }));
      }
        this.networksSelected=this.networksLocal.filter(x=>x.selected);
      field.options=field.options.concat(this.networksLocal);
      fieldsClone=field;
    }
    return fieldsClone.options;
  }

  checkAffiliationType(fieldAffiliation: SubmissionFormField){
    this.debugConsoleLog("checkAffiliationType");
    
    if(this.isAdmin && fieldAffiliation){
      if(fieldAffiliation.options){
        const optionsEmpty=fieldAffiliation.options.find(x=>x.preSelected==true);
        if(!optionsEmpty && fieldAffiliation.options.length>0){
          let field=Object.assign({}, fieldAffiliation);
          const _options = field.options.map(x => {
            return Object.assign({}, x);
          });
          _options[0].preSelected=true;
          field.options=_options;
          fieldAffiliation=field;
        }
      }
    }
    return fieldAffiliation;
  }

  conditionalEnabled(fieldForm: FormGroup): boolean {
    const fieldName = fieldForm.get('name') && fieldForm.get('name').value;
    const conditional = this.conditionalBundle[fieldName];
    if (conditional) {
      const { fieldId, optionId } = conditional;
      const form = this.getForm('id', fieldId);
      const { value }: any = form || false;
      if (value) {
        const option = value.options.find(opt => opt.id === optionId);
        const fieldKeys = Object.keys(fieldForm.controls);

        if (!option.preSelected) {
          if (fieldKeys.includes('options')) {
            fieldForm.get('options').disable();
          }
          if (fieldKeys.includes('value')) {
            fieldForm.get('value').disable();
          }
        } else {
          if (fieldKeys.includes('options')) {
            fieldForm.get('options').enable();
          }
          if (fieldKeys.includes('value')) {
            fieldForm.get('value').enable();
          }
        }
        return option.preSelected;
      }
    }
    return true;
  }

  fileURLEditable(fieldName: string): boolean {
    if (fieldName === 'File URL') {
      const contentForm = this.getForm('name', 'Upload Content');
      const options = contentForm.get('options').value;
      const selected = options.find(opt => opt.preSelected);
      if (selected) {
        return selected.display_value === 'URL' ? false : true;
      }
    }
    return false;
  }

  getForm(by: string, fieldValue: any): FormGroup {
    let control;
    this.form.controls.forEach(ctrl => {
      const fields = ctrl.get('fields') as FormArray;
      if (!control) {
        control = fields.controls.find(field => {
          if (field.get(by) && field.get(by).value === fieldValue) {
            return field;
          }
        });
      }
    });
    return control;
  }

  uploadContentChange(): void {
    this.debugConsoleLog("uploadContentChange");
    
    const content = this.getForm('name', 'Upload Content');
    const file = this.getForm('name', 'File URL');

    if (content && file) {
      const contentForm = content.get('options');
      const fileForm = file.get('value');
      contentForm.valueChanges
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(options => {
          const selected = options.find(opt => opt.preSelected);
          if (selected) {
            // if (selected.display_value === 'URL') {
            //   fileForm.setValidators([Validators.required, url]);
            // } else {
            //   fileForm.setValidators([Validators.required]);
            // }
            fileForm.setValidators([Validators.required]);
          }
          fileForm.setValue(null);
          fileForm.updateValueAndValidity();
        });
    }
  }

  createForm(sections: Array<SubmissionFormSection>): void {
    this.form = new FormArray([]);
    sections.forEach(section => {
      const { name, fields } = section;
      this.form.push(
        new FormGroup({
          name: new FormControl(name),
          fields: new FormArray(
            fields.map(field => {
              if(section.name=='Contact Information' && field.name=='Email'){
                field.value=this.userId;
              }
              const {
                fieldPosition,
                field_type,
                icon,
                id,
                name: fieldName,
                value,
                isVisible,
                options,
                position_under,
                conditional,
                validators
              } = field;

              if (options && options.length > 0) {
                this.createOptions(fieldName, options, false);
              }
              if (conditional) {
                this.createConditional(fieldName, {
                  ...conditional,
                  visible: false
                });
              }

              return new FormGroup({
                field_type: new FormControl(field_type),
                icon: new FormControl(icon),
                id: new FormControl(id),
                name: new FormControl(fieldName),
                isVisible: new FormControl(isVisible),
                placeholder: new FormControl(value),
                ...(options && options.length > 0
                  ? {
                      options: new FormArray(
                        options.map(option => {
                          const {
                            active,
                            display_value,
                            id: optionID,
                            position_order,
                            preSelected,
                            selected
                          } = option;
                          return new FormGroup({
                            active: new FormControl(active),
                            display_value: new FormControl(display_value),
                            id: new FormControl(optionID),
                            position_order: new FormControl(position_order),
                            preSelected: new FormControl(preSelected),
                            selected: new FormControl(selected)
                          });
                        })
                      )
                    }
                  : {
                      value:field.name=='Email'? new FormControl(value, validators):new FormControl(null, validators)
                    }),
                ...(position_under
                  ? { position_under: new FormControl(position_under) }
                  : { fieldPosition: new FormControl(fieldPosition) })
              });
            })
          )
        })
      );
    });
    // this.form.controls[0]
    // .get('fields')
    // .get([0])
    // .setValue(this.userId);
    // this.aditionalFormInfo();
  }

  setValidators(
    sections: Array<SubmissionFormSection>
  ): Array<SubmissionFormSection> {
    sections = sections.map(section => {
      const { name, fields } = section;
      return {
        name,
        fields: fields.map(field => {

          const validators: Array<ValidatorFn> = [];
          if (field.isRequired) {
            validators.push(Validators.required);
          }
          if (field.field_type === FieldType.TextField) {
            if(field.name){
              if (field.name.toLowerCase().includes('email')) {
              validators.push(email);
              }
            }
            // if (field.name.toLowerCase().includes('url')) {
            //   validators.push(url);
            // }
          }
          if (
            (field.field_type === FieldType.Select ||
              field.field_type === -1 ||
              field.field_type === FieldType.Radio ||
              field.field_type === FieldType.Checkbox) &&
            field.isRequired
          ) {

            this.optionsRequired = {
              ...this.optionsRequired,
              [field.name]: true
            };
          }

          return {
            ...field,
            validators
          };
        })
      };
    });
    return sections;
  }

  setDateValidators(): void {
    const startDateForm = this.getForm('name', 'Start Date (MM/DD/YYYY)');
    const endDateForm = this.getForm('name', 'End Date (MM/DD/YYYY)');

    if (startDateForm && endDateForm) {
      const startDate = startDateForm.get('value');
      const endDate = endDateForm.get('value');
        startDate.setValidators([
          Validators.required,
          dateRange('lower', endDate)
        ]);

        endDate.setValidators([
          Validators.required,
          dateRange('higher', startDate)
        ]);

      startDate.updateValueAndValidity();
      endDate.updateValueAndValidity();
    }
  }

  sortFields(
    sections: Array<SubmissionFormSection>
  ): Array<SubmissionFormSection> {
    const withPosition: Array<SubmissionFormField> = [];
    sections.forEach(section => {
      withPosition.push(
        ...section.fields.filter(field => field.position_under)
      );
    });
    sections = sections.map(section => {
      const { name, fields } = section;
      return {
        name,
        fields: fields.filter(field => !field.position_under)
      };
    });

    withPosition.forEach(position => {
      sections = sections.map(section => {
        const { name, fields } = section;
        const index = fields.findIndex(
          field => field.id === position.position_under
        );
        if (index > -1) {
          fields.splice(index + 1, 0, position);
        }
        return {
          name,
          fields
        };
      });
    });
    return sections;
  }

  createOptions(fieldName: string, fieldOptions: Array<FieldOption>, isPanel:boolean): void {
    this.debugConsoleLog("createOptions");
    
    const options = fieldOptions.map(opt => ({
      label: opt.display_value,
      value: opt.id
    }));
    if(!isPanel){
      this.optionsBundle = {
        ...this.optionsBundle,
        ...{ [fieldName]: options }
      };
    }else{
      this.optionsPanel = {
        ...this.optionsPanel,
        ...{ [fieldName]: options }
      };
    }
  }

  createConditional(fieldName: string, conditional: Conditional): void {
    this.conditionalBundle = {
      ...this.conditionalBundle,
      ...{ [fieldName]: conditional }
    };
  }

  aditionalFormInfo(): void {
    this.form.push(
      new FormGroup({
        fields: new FormArray([
          new FormGroup({
            name: new FormControl(null),
            field_type: new FormControl(FieldType.Checkbox),
            options: new FormArray([
              new FormGroup({
                display_value: new FormControl(
                  'I have agreed by the terms and conditions of the Guidelines.'
                ),
                preSelected: new FormControl(false, Validators.requiredTrue),
                selected: new FormControl(false)
              })
            ])
          })
          // new FormGroup({
          //   field_type: new FormControl(null),
          //   captcha: new FormControl(null, Validators.required)
          // })
        ])
      })
    );
  }

  getOptions(fieldName: string): Array<Option> {
    //this.debugConsoleLog("getOptions");
    
    return this.optionsBundle[fieldName];
  }

  getOptionsPanel(fieldName:string):Array<Option>{
    //this.debugConsoleLog("getOptionsPanel");    
   return this.optionsPanel[fieldName];
  }

  getSelectValue(form: FormArray): number {
    const option = form.controls.find(ctrl => {
      return ctrl.get('preSelected').value;
    });
    return option ? option.get('id').value : null;
  }

  getSelectedItems(form: FormArray, index: number): boolean {
    //this.debugConsoleLog("getSelectedItems");    
    return form.get([index]).get('preSelected').value;
  }

  getSelectedItemsPanels(key_network:string, index: number):boolean{
    //this.debugConsoleLog("getSelectedItemsPanels");    
    return Boolean(this.entrysPanel?.[key_network]?.[index]?.selected);    
    }

  radioValueChange(form: FormArray, index: number): void {
    this.debugConsoleLog("radioValueChange");
    
    form.controls.forEach((ctrl, i) => {
      if (i === index) {
        ctrl.get('preSelected').setValue(true);
        ctrl.get('selected').setValue(true);
      } else {
        ctrl.get('preSelected').setValue(false);
        ctrl.get('selected').setValue(false);
      }
    });
  }

  radioValueChangePanels(key_network: string, index: number): void {
    this.debugConsoleLog("radioValueChangePanels");
    
    this.entrysPanel[key_network].forEach(panel=>panel.selected=false);
    this.entrysPanel[key_network][index].selected=true;
    let key_network_n=Number(key_network);
    this.networkRelationPanels.forEach(netPanRel=>{
      if(netPanRel.id==key_network_n){
        netPanRel.panels.forEach(panel=>panel.panelIsSelected=false);
        netPanRel.panels[index].panelIsSelected=true;
      }
    } );
  }

  selectValueChange(value: number, form: FormArray): void {
    this.debugConsoleLog("selectValueChange");
    
   form.controls.forEach(ctrl => {
      if (ctrl.get('id').value === value) {
        ctrl.get('preSelected').setValue(true);
        ctrl.get('selected').setValue(true);
      } else {
        ctrl.get('preSelected').setValue(false);
        ctrl.get('selected').setValue(false);
      }
    });
  }

  checkboxValueChange(
    event: MatCheckboxChange,
    form: FormGroup,
    index: number,
    termsNcond: boolean
  ): void {
    this.debugConsoleLog("checkboxValueChange");
    const { checked } = event;
    form.get('options').get([index]).get('preSelected').setValue(checked);
    form.get('options').get([index]).get('selected').setValue(checked);
    form.markAsDirty();
    form.markAsTouched();
    this.cdRef.detectChanges();
    if(!termsNcond){
      this.updatePanelsOptions(true);
    }
     
  }

  updatePanelsOptions(isCheckBox: boolean) {
    this.debugConsoleLog("updatePanelsOptions");
    
    if (this.isAdmin && this.networkRelationPanels) {
      // Relations Panels
      this.entrysPanel = {};
      this.networkRelationPanels.forEach(x => {
        if (x.type === 'local') {
          const _panels = x.panels.map((panel, index) => ({
            active: panel.panelIsActive,
            preSelected: panel.panelIsPreSelected,
            selected: panel.panelIsSelected,
            id: panel.panelId,
            display_value: panel.panelName,
            position_order: index
          }));
  
          this.entrysPanel[x.id] = _panels;
        }
      });
      
      // Get options for networks
      let selectPublic = null;
      let _optionsNetwork;
      if (!isCheckBox) {
        _optionsNetwork = this.sections[1].fields[0].options;
      } else {
        _optionsNetwork = this.form.controls[1].get('fields').value[0].options;
      }
      selectPublic = _optionsNetwork.find(x => x.display_value.includes('Public') && x.preSelected);
  
      // Show or hide public panels
      this.showPanelPublic = !!selectPublic;
           
      const networksSelected = _optionsNetwork.filter(element => element.selected)
        .map(element => this.networksLocal.find(x => x.id === element.id))
        .filter(network => network !== undefined);  
      // Update entry panels based on selected networks
      this.networksSelected = networksSelected;
      this.networksSelected.forEach(network => {
        network.selected=true;
        network.preSelected=true;
        const panels = this.entrysPanel[network.id];
        if (panels) {
          panels.forEach(panel => {
            this.createOptions(network.display_value, panels, true);
          });
        }
      });
  
      // Remove panels that do not belong to selected networks
      const _entrysPanel = {};
      networksSelected.forEach(network => {
        if (this.entrysPanel[network.id]) {
          _entrysPanel[network.id] = this.entrysPanel[network.id];
        }
      });
      this.entrysPanel = _entrysPanel;
  
      // Update networksAdmin based on selected networks
      this.networksAdmin = this.networksAdmin.map(adminNetwork => {
        const isSelected = networksSelected.some(network => network.id === adminNetwork.id);
        return {
          ...adminNetwork,
          preSelected: isSelected,
          selected: isSelected
        };
      });
  
      // Map selected panels
      const panelSelected = [];
      Object.values(this.entrysPanel).forEach(panels => {
        panels.forEach(panel => {
          if(panel.selected){
            panelSelected.push(panel.id);  
          }
          
        });
      });
  
      // Update networkRelationPanels with selected panels
      this.networkRelationPanels = this.networkRelationPanels.map(networkRel => {
        const updatedPanels = networkRel.panels.map(panelRel => {
          if (panelSelected.includes(panelRel.panelId)) {
            return { ...panelRel, panelIsPreSelected: true, panelIsSelected: true };
          } else {
            return { ...panelRel, panelIsPreSelected: false, panelIsSelected: false };
          }
        });
        return { ...networkRel, panels: updatedPanels };
      });
  
      // Update form validation
      if (this.showPanelPublic) {
        this.optionsRequired['Panel'] = true;
      } else {
        this.optionsRequired['Panel'] = false;
        const panel = this.form ? this.getForm('name', 'Panel') : null;
        if (panel) {
          panel.setErrors(null);
          panel.updateValueAndValidity();
        }
      }
    }
  }
  
  uploadFile(file: File | { maxSize: boolean }, fileForm: FormGroup): void {
    this.debugConsoleLog("uploadFile");
    
    if (file instanceof File) {
      this.fileLoading = true;
      this.store.dispatch(new UploadSubmissionFormFile(file));   
      const sub = this.actions$
        .pipe(
          ofActionSuccessful(
            UploadSubmissionFormFileSuccess,
            UploadSubmissionFormFileError
          )
        )
        .subscribe(action => {
          if (action instanceof UploadSubmissionFormFileSuccess) {
            const { payload } = action;
            fileForm.get('value').setValue(payload);
          }
          if (action instanceof UploadSubmissionFormFileError) {
            fileForm.get('value').setValue(null);
          }
          this.fileLoading = false;
          sub.unsubscribe();
        });
    } else {
      fileForm.get('value').setErrors(file);
      fileForm.get('value').markAsTouched();
    } 
  }

  displayError(formField: FormGroup): string {
    if (this.optionsRequired[formField.get('name').value]) {
      let message = `${
        formField.get('name').value
      } needs at least one item selected`;
      const opts = formField.get('options') as FormArray;
      opts.controls.forEach(opt => {
        if (opt.get('preSelected').value) {
          message = null;
        }
      });
      if (message) {
        formField.setErrors({ required: true });
      } else {
        formField.setErrors({});
        formField.updateValueAndValidity();
      }
      return message;
    }
    return null;
  }

  formSubmitted(token: string, from: string, to: string): void {
    this.debugConsoleLog("formSubmitted");
    
    this.matDialog
      .open(SubmissionSuccessComponent, {
        width: '500px',
        ariaLabel: 'Data Submitted Successfully',
        data: {
          token,
          from,
          to
        }
      })
      .afterClosed()
      .subscribe((reset: boolean) => {
        if (reset) {
          this.resetForm();
        }
      });
  }

  resetForm(): void {
    this.debugConsoleLog("resetForm");
    
     this.sections = this.sections.map(section => {
      const { fields, name } = section;
      return {
        name,
        fields: fields.map(field => {
          if (
            field.field_type !== FieldType.Checkbox &&
            field.field_type !== FieldType.Radio &&
            field.field_type !== FieldType.Select
          ) {
            return {
              ...field,
              value: null
            };
          }
          return {
            ...field,
            options: field.options.map(option => {
              return {
                ...option,
                preSelected: false
              };
            })
          };
        })
      };
    });
    this.createForm(this.sections);
    this.cdRef.detectChanges();
    this.updatePanelsOptions(false);
  }

  checkOptionsPanelSave(fieldClone: SubmissionFormField): FieldOption[] {
    this.debugConsoleLog("checkOptionsPanelSave");
    
    let field = Object.assign({}, fieldClone);
    let _options = field.options.map(x => {
      return Object.assign({}, x);
    });
    if(this.showPanelPublic)
      _options=_options.filter(x=>x.selected);
      else
      _options=[];
      if(this.networksSelected.length>0){
        Object.keys(this.entrysPanel).forEach(x => {
          this.entrysPanel[x].forEach(panel => {
            if (panel.selected)
              _options.push(panel);
          })
      })
      }
    
    field.options = _options;
    fieldClone = field;
    return fieldClone.options;
  }

  saveForm(): void {
    this.debugConsoleLog("saveForm");
    
    this.saveFormComplete();
    const button=document.getElementById('btn_submit') as HTMLButtonElement;
    button.disabled=true;
    const timer$=timer(5000);
    timer$.subscribe(val=>{
      button.disabled=false;  
    });
  }

  saveFormComplete(){
    this.debugConsoleLog("saveFormComplete");
    
    this.captchaTandCError=false;
    const sections = this.form
      .getRawValue()
      .filter(section => section.name && section);
      if(this.form.valid){
        this.showErrors=false;
        let _newSubmissionForm = Object.assign({}, this.submissionForm);
        _newSubmissionForm.sections = this.form.value;
        _newSubmissionForm.sections.splice(2);
        
        
        
        if (this.isAdmin) {
          let _sectionsClone = [];
          let fields = [];
          _newSubmissionForm.type = "Local";
          _newSubmissionForm.sections.forEach(val => _sectionsClone.push(Object.assign({}, val)));
          _sectionsClone[1].fields.forEach(val => fields.push(Object.assign({}, val)));

          const fieldPanel = _sectionsClone[1].fields[1];
          let optionsPanel = this.checkOptionsPanelSave(fieldPanel);
          optionsPanel.forEach(panel => panel.preSelected=true);
          fields.find(x => x.name === "Panel").options = optionsPanel;
          _sectionsClone.find(section => section.name === "Ad Request").fields = fields;
          _newSubmissionForm.sections = _sectionsClone;
        }


        
        const submissionForm = {
          ..._newSubmissionForm,
          sections: _newSubmissionForm.sections.map(section => {
            const { name, fields } = section;
            return {
              name,
              fields: fields.map(f => {
                let value = f.value;
                if (f.field_type === FieldType.Date) {
                  value = this.featuresService.formatDate(f.value);
                }
                return {
                  ...f,
                  value
                };
              })
            };
          })
        };
        this.store.dispatch(new UpdateSubmissionForm(submissionForm, this.isAdmin));

      }else{
        this.showErrors=true;
        if(this.invalidControls.length<=0){
          this.captchaTandCError=true;
        }
      }
  }

  public findInvalidControlsRecursive(formToInvestigate:FormGroup|FormArray) {
    var invalidControls = [];
    let recursiveFunc = (form:FormGroup|FormArray) => {
      Object.keys(form.controls).forEach(name => {
        const control = form.get(name);
        if (control instanceof FormGroup) {
          recursiveFunc(control);
        } else if (control instanceof FormArray) {
          recursiveFunc(control);
        }
        if (control.errors){
          if(control.value && control.value.name){
            invalidControls.push(control.value.name )
          }
          if(form.value.name){
            invalidControls.push(form.value.name )
          }
        }
      });
    }
    recursiveFunc(formToInvestigate);
    return invalidControls;
  }


  debugConsoleLog(functionName:String){
   // console.log("------------"+ functionName +"----------");
   // console.log(this.entrysPanel);
   // console.log(this.networksSelected);
   // console.log(this.networkRelationPanels);
  }
}


